import React from "react";
import cx from "classnames";
import dayjs from "dayjs";
import stylesV2 from "./Banner.module.scss";
import stylesV3 from "./BannerV2.module.scss";
import { useSchedulingABVariant } from "../../utils/useSchedulingABVariant";

export interface BannerProps {
  formattedPhone: string;
}

declare let bannerSettings: string;

export const Banner = () => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const bsetting = bannerSettings ? bannerSettings.split("~") : null;
  if (bsetting === null) return null;

  const showBanner =
    bsetting.length > 0 &&
    bsetting[0] === "publish" &&
    dayjs(bsetting[2]).add(1, "day").isAfter(dayjs());
  React.useEffect(() => {
    if (!containerRef.current) return;
    const links = containerRef.current.querySelectorAll<HTMLAnchorElement>("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noreferrer");
    });
  }, [bsetting?.[3]]);
  if (showBanner) {
    return (
      <div
        className={cx(styles.banner, styles[bsetting[1]], {
          [styles.bannerFont]: isV3,
        })}
        ref={containerRef}
        dangerouslySetInnerHTML={{
          __html: bsetting[3].replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&"),
        }}
      />
    );
  } else {
    return null;
  }
};
